import http from "../../../util/axios";

export default {
  //登录后的数据
  basicInfo(params) {
    return http.get("/app/teacher/center/basicInfo", { params });
  },
  //心跳记录
  courseHeartBeat(params) {
    return http.get("/app/teacher/courseHeartBeat", { params });
  },
  //查询教师课程
  queryTeacherCourses(params) {
    return http.get("/app/teacher/queryTeacherCourses", { params });
  },
  //切换项目
  switchClass(params) {
    return http.get("/app/teacher/center/switchClass", { params });
  },
  //查询课程回放
  queryPlaybackCourses(params) {
    return http.get("/app/teacher/queryPlaybackCourses", { params });
  },
  //获取课程网页直播地址
  getWebCastUrl(params) {
    return http.get("/app/teacher/getWebCastUrl", { params });
  },
  //获取课程客户端直播地址
  getClientLiveUrl(params) {
    return http.get("/app/teacher/getClientLiveUrl", { params });
  },
  //课程回放
  coursePlayback(params) {
    return http.get("/app/teacher/coursePlayback", { params });
  },
  //语言
  lang(params) {
    return http.get("/lang/list", { params });
  },
  //查询教师课程列表
  queryTeacherProject(params) {
    return http.get("/app/teacher/queryTeacherProject", { params });
  },
  //跳转到腾讯会议
  jumpMeeting(params) {
    return http.get(`/app/teacher/jumpMeeting/${params}`);
  }
};



// WEBPACK FOOTER //
// ./src/api/teacher/home/index.js